<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <Nav ref="nav"></Nav>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-breadcrumb__inner"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="parkOverviewLink"
            v-show="type == 3 || type == 4 || type == 5 || type == 6"
            >{{ name1 }}</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{ path: '/BusinessCooperation' }"
            v-show="type == 2"
            >{{ name1 }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ name2 }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>

    <!-- AI新闻详情 -->
    <div v-if="type == 5" class="indexDetail index_center">
      <div class="indexDetail_title">
        <div class="indexDetail_title_text">{{ title }}</div>
      </div>
      <div class="ai_news_detail_meta">
        <span v-if="categoryText" class="ai_news_detail_tag">{{ categoryText }}</span>
        <span
          v-for="badge in aiNewsBadges"
          :key="badge"
          class="ai_news_detail_badge"
          :style="{ background: badgeMap[badge] ? badgeMap[badge].color : '#909399' }"
        >{{ badgeMap[badge] ? badgeMap[badge].text : badge }}</span>
        <span class="ai_news_detail_date">{{ updateTime }}</span>
      </div>
      <div v-if="aiNewsCover" class="ai_news_detail_cover">
        <img :src="aiNewsCover" alt="" />
      </div>
      <div class="indexDetail_line"></div>
      <div class="indexDetail_content ai_news_detail_content" v-html="newsContent"></div>
    </div>

    <!-- 校园方案详情 -->
    <div v-else-if="type == 6" class="indexDetail index_center">
      <div class="indexDetail_title">
        <div class="indexDetail_title_text">{{ title }}</div>
      </div>
      <div class="campus_detail_meta">
        <span class="campus_detail_school">{{ campusInfo ? campusInfo.school : "" }}</span>
        <span
          v-if="campusStatusText"
          class="campus_detail_status"
          :style="{ color: campusStatusColor, background: campusStatusColor + '1a' }"
        >{{ campusStatusText }}</span>
        <span class="campus_detail_date">{{ updateTime }}</span>
      </div>
      <div class="indexDetail_line"></div>
      <div class="indexDetail_content contribution_content" v-html="newsContent"></div>
    </div>

    <!-- 论坛中心：征稿详情 -->
    <div v-else-if="type == 3" class="indexDetail index_center">
      <div class="indexDetail_title">
        <div class="indexDetail_title_text">{{ title }}</div>
      </div>
      <div class="contribution_detail_meta">
        <span
          class="contribution_level"
          :style="{ background: levelColor }"
        >{{ levelText }}</span>
        <span class="contribution_status">{{ statusText }}</span>
      </div>
      <div class="contribution_info">
        <span>投稿截止：{{ contributionInfo ? contributionInfo.deadline : "" }}</span>
        <span>已投稿：{{ contributionInfo ? contributionInfo.submittedCount : 0 }}篇</span>
      </div>
      <div class="indexDetail_line"></div>
      <div class="indexDetail_content contribution_content" v-html="contributionInfo ? contributionInfo.desc : ''"></div>
      <div class="detail_footer">
        <el-button
          v-if="contributionInfo && contributionInfo.status === 'open'"
          class="detail_submit"
          @click="handleDetailContribute"
        >我要投稿</el-button>
        <el-button
          v-else
          class="detail_submit is_closed"
          disabled
        >已截止</el-button>
      </div>
    </div>

    <!-- 普通图文详情 -->
    <div v-else class="indexDetail index_center">
      <div class="indexDetail_title">
        <div class="indexDetail_title_text">{{ title }}</div>
      </div>
      <div class="indexDetail_title_date">
        <p>{{ updateTime }}</p>
      </div>
      <div class="indexDetail_title_source">
        <p>{{ source }}</p>
      </div>
      <div class="indexDetail_line"></div>
      <div class="indexDetail_content" v-html="newsContent"></div>
    </div>

    <ContributionDialog
      :visible.sync="contributionVisible"
      :theme="currentTheme"
      @success="handleContributionSuccess"
    ></ContributionDialog>
    <Foot></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import { getNewsInfoApi, getPlanInfoApi, getContributionInfoApi, getAiNewsInfoApi, getCampusProposalInfoApi } from "@/api/index";
import { getAiNewsInfo as getAiNewsInfoMock, getCampusProposalInfo as getCampusProposalInfoMock, aiNewsCategoryTabs } from "@/data/newsData";
import ContributionDialog from "./components/ContributionDialog";

export default {
  components: { Foot, Nav, ContributionDialog },
  data() {
    return {
      id: "",
      newsContent: "",
      title: "",
      updateTime: "",
      type: "",
      name1: "",
      name2: "",
      source: "",
      currentTheme: null,
      contributionVisible: false,
      contributionInfo: null,
      levelMap: {
        urgent: { text: "急", color: "#f56c6c" },
        normal: { text: "征", color: "#2968bd" },
        medium: { text: "中", color: "#67c23a" },
      },
      contributionStatusMap: {
        open: "征稿中",
        closed: "已截止",
      },
      aiNewsCover: "",
      aiNewsCategory: "",
      aiNewsBadges: [],
      badgeMap: {
        hot: { text: "热门", color: "#f56c6c" },
        new: { text: "最新", color: "#67c23a" },
      },
      campusInfo: null,
      campusStatusMap: {
        adopted: { text: "已采纳", color: "#67c23a" },
        reviewing: { text: "审核中", color: "#e6a23c" },
        pending: { text: "未采纳", color: "#c0c4cc" },
      },
    };
  },
  computed: {
    isLogged() {
      return this.$store.getters["auth/isLogged"];
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
    categoryText() {
      const tab = aiNewsCategoryTabs.find((item) => item.key === this.aiNewsCategory);
      return tab ? tab.label : "";
    },
    parkOverviewLink() {
      if (this.type == 5) {
        return { path: "/ParkOverview", query: { tab: 3 } };
      }
      if (this.type == 3) {
        return { path: "/ParkOverview", query: { tab: 2 } };
      }
      if (this.type == 6) {
        return { path: "/ParkOverview", query: { tab: 5 } };
      }
      return { path: "/ParkOverview" };
    },
    campusStatusText() {
      return this.campusInfo && this.campusStatusMap[this.campusInfo.status]
        ? this.campusStatusMap[this.campusInfo.status].text
        : "";
    },
    campusStatusColor() {
      return this.campusInfo && this.campusStatusMap[this.campusInfo.status]
        ? this.campusStatusMap[this.campusInfo.status].color
        : "#909399";
    },
    levelText() {
      return this.contributionInfo && this.levelMap[this.contributionInfo.level]
        ? this.levelMap[this.contributionInfo.level].text
        : "";
    },
    levelColor() {
      return this.contributionInfo && this.levelMap[this.contributionInfo.level]
        ? this.levelMap[this.contributionInfo.level].color
        : "#909399";
    },
    statusText() {
      return this.contributionInfo && this.contributionStatusMap[this.contributionInfo.status]
        ? this.contributionStatusMap[this.contributionInfo.status]
        : "";
    },
  },
  watch: {
    loginPromptSeq(val) {
      if (!val) return;
      this.contributionVisible = false;
      if (this.$refs.nav) this.$refs.nav.openLoginDialog();
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.type == 2) {
      this.getPlanInfo();
      this.name1 = "解决方案";
      this.name2 = "方案详情";
    } else if (this.type == 3) {
      this.getContributionInfo();
      this.name1 = "企业动态";
      this.name2 = "征稿详情";
    } else if (this.type == 5) {
      this.getAiNewsInfo();
      this.name1 = "企业动态";
      this.name2 = "AI新闻详情";
    } else if (this.type == 6) {
      this.getCampusProposalInfo();
      this.name1 = "企业动态";
      this.name2 = "方案详情";
    } else {
      this.getNewsInfo();
      this.name1 = "企业动态";
      this.name2 = "动态详情";
    }
    //征稿/AI新闻详情来自企业动态页，导航仍应高亮企业动态
    const tabbar = this.type == 3 || this.type == 5 || this.type == 6 ? "4" : this.type;
    this.$cookies.set("tabbar", tabbar);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
  },
  methods: {
    //获取行业动态详情
    getNewsInfo() {
      var data = {
        id: this.id,
      };
      getNewsInfoApi(data).then((res) => {
        // console.log("动态详情", res);
        this.newsContent = res.data.content;
        this.title = res.data.title;
        this.updateTime = res.data.updateTime;
        this.source = res.data.source || "佚名";
      });
    },
    //获取解决方案详情
    getPlanInfo() {
      var data = {
        id: this.id,
      };
      getPlanInfoApi(data).then((res) => {
        this.newsContent = res.data.content;
        this.title = res.data.title;
        this.updateTime = res.data.updateTime;
      });
    },
    //获取AI新闻详情
    getAiNewsInfo() {
      getAiNewsInfoApi({ id: this.id }).then((res) => {
        if (res.code !== 0 || !res.data) {
          this.loadAiNewsFallback();
          return;
        }
        this.applyAiNewsInfo(res.data);
      }).catch(() => {
        this.loadAiNewsFallback();
      });
    },
    loadAiNewsFallback() {
      getAiNewsInfoMock({ id: this.id }).then((res) => {
        if (res.code !== 0 || !res.data) {
          this.$message.error(res.msg || "新闻不存在");
          return;
        }
        this.applyAiNewsInfo(res.data);
      });
    },
    //获取校园方案详情
    getCampusProposalInfo() {
      getCampusProposalInfoApi({ id: this.id }).then((res) => {
        if (res.code !== 0 || !res.data) {
          this.loadCampusProposalFallback();
          return;
        }
        this.applyCampusProposalInfo(res.data);
      }).catch(() => {
        this.loadCampusProposalFallback();
      });
    },
    loadCampusProposalFallback() {
      getCampusProposalInfoMock({ id: this.id }).then((res) => {
        if (res.code !== 0 || !res.data) {
          this.$message.error(res.msg || "方案不存在");
          return;
        }
        this.applyCampusProposalInfo(res.data);
      });
    },
    applyCampusProposalInfo(data) {
      this.campusInfo = data;
      this.title = data.title || "";
      this.newsContent = data.desc || "";
      this.updateTime = data.createTime || "";
    },
    applyAiNewsInfo(data) {
      this.title = data.title || "";
      this.newsContent = data.content || data.summary || "";
      this.updateTime = data.createTime || "";
      this.aiNewsCover = data.imageUrl || "";
      this.aiNewsCategory = data.category || "";
      this.aiNewsBadges = Array.isArray(data.badges)
        ? data.badges.filter(Boolean)
        : data.badges
          ? String(data.badges).split(",").filter(Boolean)
          : [];
    },
    //获取论坛中心征稿详情
    getContributionInfo() {
      getContributionInfoApi({ id: this.id }).then((res) => {
        if (res.code !== 0 || !res.data) {
          this.$message.error(res.msg || "征稿不存在");
          return;
        }
        this.contributionInfo = res.data;
        this.title = res.data.title;
      });
    },
    //详情页投稿：未登录时打开全局登录弹窗，登录后可再次点击投稿
    handleDetailContribute() {
      if (!this.contributionInfo || this.contributionInfo.status !== "open") return;
      if (!this.isLogged) {
        this.$refs.nav.openLoginDialog();
        return;
      }
      this.currentTheme = {
        id: this.contributionInfo.id,
        title: this.contributionInfo.title,
      };
      this.contributionVisible = true;
    },
    //假投稿后同步详情页统计，列表页重新获取时也会从同一份假数据中读取
    handleContributionSuccess() {
      if (this.contributionInfo) {
        this.contributionInfo.submittedCount += 1;
      }
    },
  },
};
</script>
<style scoped>
.index_center {
  width: 980px;
  margin: 0 auto;
}

.indexDetail {
  margin-top: 70px;
  justify-content: space-between;
}

.indexDetail_title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.indexDetail_title_text {
  font-family: "楷体";
  font-weight: bold;
  font-size: 30px;
  color: #333333;
}

.indexDetail_title_date {
  font-size: 16px;
  color: #999999;
  display: flex;
  justify-content: flex-end;
  /* padding-bottom: 30px; */
}

.indexDetail_title_date p {
  padding-left: 10px;
}
.indexDetail_title_source {
  display: flex;
  justify-content: flex-end;
  color: #999999;
  margin-bottom: 15px;
}

.indexDetail_line {
  border-bottom: 1px solid #000;
}

.indexDetail_content {
  padding-top: 37px;
  padding-bottom: 200px;
}

.indexDetail_content /deep/ img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px 0;
}

.contribution_detail_meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
}

.contribution_level {
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 13px;
  text-align: center;
}

.contribution_status {
  font-size: 13px;
  color: #2968bd;
}

.contribution_info {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 14px;
  font-size: 14px;
  color: #999999;
}

.contribution_content {
  padding-top: 37px;
  padding-bottom: 60px;
  font-size: 15px;
  color: #333333;
  line-height: 28px;
}

.contribution_content /deep/ p {
  margin: 0 0 16px;
}

.contribution_content /deep/ img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px 0;
}

.campus_detail_meta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.campus_detail_school {
  font-size: 14px;
  font-weight: 600;
  color: #2968bd;
}

.campus_detail_status {
  font-size: 12px;
  border-radius: 3px;
  padding: 2px 10px;
  line-height: 20px;
}

.campus_detail_date {
  font-size: 13px;
  color: #999999;
}

.detail_footer {
  text-align: center;
  padding-bottom: 200px;
}

.detail_submit {
  min-width: 120px;
  height: 40px;
  margin-right: 16px;
  color: #ffffff;
  background: #1b63a7;
  border: none;
  border-radius: 4px;
  font-weight: 600;
}

.detail_submit:hover {
  background: #2968bd;
  border-color: #2968bd;
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.detail_submit.is_closed {
  color: #ffffff;
  background: #c0c4cc;
  cursor: not-allowed;
}

.ai_news_detail_meta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.ai_news_detail_tag {
  font-size: 12px;
  color: #409eff;
  border: 1px solid #409eff;
  border-radius: 3px;
  padding: 1px 8px;
  line-height: 18px;
}

.ai_news_detail_badge {
  font-size: 12px;
  color: #fff;
  border-radius: 3px;
  padding: 2px 8px;
  line-height: 18px;
}

.ai_news_detail_date {
  font-size: 13px;
  color: #999999;
}

.ai_news_detail_cover {
  width: 100%;
  max-height: 360px;
  margin-bottom: 24px;
  border-radius: 4px;
  overflow: hidden;
}

.ai_news_detail_cover img {
  width: 100%;
  max-height: 360px;
  object-fit: cover;
  display: block;
}

.ai_news_detail_content {
  font-size: 15px;
  color: #333333;
  line-height: 28px;
}

.ai_news_detail_content /deep/ p {
  margin: 0 0 16px;
}

.ai_news_detail_content /deep/ img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px 0;
}





.breadcrumb_center {
  background-color: #f6f7f8;
  display: flex;
  /*width: 1200px;*/
  justify-content: space-around;
  height: 50px;
  margin: 0 auto;
}

.el-breadcrumb__inner {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}

.el-breadcrumb__inner img {
  padding: 0 20px 0px 0;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}
</style>


// WEBPACK FOOTER //
// src/views/detail.vue